import { render, staticRenderFns } from "./OpenMultiplePeopleCase.vue?vue&type=template&id=793ce342&scoped=true&"
import script from "./OpenMultiplePeopleCase.vue?vue&type=script&lang=js&"
export * from "./OpenMultiplePeopleCase.vue?vue&type=script&lang=js&"
import style0 from "./OpenMultiplePeopleCase.vue?vue&type=style&index=0&id=793ce342&lang=less&scoped=true&"
import style1 from "./OpenMultiplePeopleCase.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793ce342",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('793ce342')) {
      api.createRecord('793ce342', component.options)
    } else {
      api.reload('793ce342', component.options)
    }
    module.hot.accept("./OpenMultiplePeopleCase.vue?vue&type=template&id=793ce342&scoped=true&", function () {
      api.rerender('793ce342', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/multiplePeopleCase/components/OpenMultiplePeopleCase/OpenMultiplePeopleCase.vue"
export default component.exports